import React from 'react';

const ImageMarquee = () => {
  // Array of image filenames from public directory
  const images = [
    'images/pond3.jpg',
    'images/water1.jpg', 
    'images/water3.jpg',
    'images/pond1.png',
  
  ];

  return (
    <div className="w-full bg-gradient-to-b from-slate-50 to-white py-20">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        .marquee-font {
          font-family: 'Inter', system-ui, sans-serif;
        }

        @keyframes marquee {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        .marquee-content {
          animation: marquee 40s linear infinite;
          display: flex;
          gap: 1.5rem;
        }

        .marquee-container:hover .marquee-content {
          animation-play-state: paused;
        }

        .image-card {
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .image-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
        }

        .gradient-overlay {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 51, 234, 0.1) 100%);
        }
      `}</style>
      
      <div className="w-full px-4 sm:px-6 lg:px-8 marquee-font">
        
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1V4zm2 2V5h1v1h-1z" clipRule="evenodd" />
            </svg>
            Conservation Gallery
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6 leading-tight">
            Waterbody Conservation
            <span className="block text-blue-600">Success Stories</span>
          </h2>
          <p className="text-slate-600 text-xl max-w-3xl mx-auto leading-relaxed">
            Discover transformative waterbody strengthening projects across Tamil Nadu, 
            showcasing sustainable conservation efforts and community impact
          </p>
        </div>

        {/* Premium Marquee Container */}
        <div className="relative">
          {/* Background decorative elements */}
          <div className="absolute inset-0 gradient-overlay rounded-3xl"></div>
          
          <div className="relative bg-white/80 backdrop-blur-sm rounded-3xl border border-slate-200/60 shadow-2xl overflow-hidden marquee-container">
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent"></div>
            
            <div className="p-8 lg:p-12">
              <div className="marquee-content">
                {/* First set of images */}
                {images.map((image, index) => (
                  <div key={`first-${index}`} className="flex-shrink-0">
                    <div className="image-card w-96 h-72 rounded-2xl overflow-hidden bg-slate-100 shadow-lg border border-slate-200/50">
                      <div className="relative h-full group">
                        <img
                          src={`/${image}`}
                          alt={`Waterbody conservation project ${index + 1}`}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                        <div className="w-full h-full hidden items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 text-slate-500">
                          <div className="text-center">
                            <div className="w-16 h-16 bg-slate-300/50 rounded-2xl flex items-center justify-center mx-auto mb-4">
                              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                <circle cx="8.5" cy="8.5" r="1.5"/>
                                <polyline points="21,15 16,10 5,21"/>
                              </svg>
                            </div>
                            <p className="text-sm font-medium">Project Image</p>
                            <p className="text-xs text-slate-400 mt-1">Loading...</p>
                          </div>
                        </div>
                        
                        {/* Overlay gradient */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        
                       
                      </div>
                    </div>
                  </div>
                ))}
                
                {/* Duplicate set for seamless loop */}
                {images.map((image, index) => (
                  <div key={`second-${index}`} className="flex-shrink-0">
                    <div className="image-card w-96 h-72 rounded-2xl overflow-hidden bg-slate-100 shadow-lg border border-slate-200/50">
                      <div className="relative h-full group">
                        <img
                          src={`/${image}`}
                          alt={`Waterbody conservation project ${index + 1}`}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                        <div className="w-full h-full hidden items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 text-slate-500">
                          <div className="text-center">
                            <div className="w-16 h-16 bg-slate-300/50 rounded-2xl flex items-center justify-center mx-auto mb-4">
                              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                <circle cx="8.5" cy="8.5" r="1.5"/>
                                <polyline points="21,15 16,10 5,21"/>
                              </svg>
                            </div>
                            <p className="text-sm font-medium">Project Image</p>
                            <p className="text-xs text-slate-400 mt-1">Loading...</p>
                          </div>
                        </div>
                        
                        {/* Overlay gradient */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        
                        {/* Project number badge */}
                        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm text-slate-700 px-3 py-1 rounded-full text-sm font-semibold shadow-lg">
                       
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Instructions */}
        <div className="text-center mt-12">
          <div className="inline-flex items-center gap-3 bg-slate-100 text-slate-600 px-6 py-3 rounded-full">
            <svg className="w-5 h-5 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            <span className="text-sm font-medium">Hover to pause • Scroll to explore</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ImageMarquee;